import { destroy as destroyRF } from 'redux-form'
import { destroy as destroySFM, prevFetch } from 'loankeeper-common/helpers/SimpleFetchManager'

//@ts-ignore
import { destroy as destroyLKG } from 'shared/LKGrid'
import { INSTANCE_NAME, SELECTOR_NAME } from './constants'
import { accountSearchPostAgain, destroyAccounts } from 'src/store/account'

export const closeAccGrid = () => destroyLKG(INSTANCE_NAME)
export const closeSearchBar = () => destroyRF(INSTANCE_NAME)
// export const deleteAccounts = () => destroySFM(INSTANCE_NAME)
export const deleteAccounts = () => destroyAccounts(INSTANCE_NAME)
export const destroy = () => [closeAccGrid(), closeSearchBar(), deleteAccounts()]

// export const searchAgainAccounts = () => prevFetch({ instanceName: INSTANCE_NAME })
export const searchAgainAccounts = () => accountSearchPostAgain(INSTANCE_NAME)

export const closeAccGridSelector = () => destroyLKG(SELECTOR_NAME)
export const closeSearchBarSelector = () => destroyRF(SELECTOR_NAME)
// export const deleteAccountsSelector = () => destroySFM(SELECTOR_NAME)
export const deleteAccountsSelector = () => destroyAccounts(SELECTOR_NAME)
